import { render, staticRenderFns } from "./CanjeMasivo.vue?vue&type=template&id=3d8981c3&"
import script from "./CanjeMasivo.vue?vue&type=script&lang=js&"
export * from "./CanjeMasivo.vue?vue&type=script&lang=js&"
import style0 from "./CanjeMasivo.vue?vue&type=style&index=0&id=3d8981c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports